module.exports = __webpack_public_path__ + "img/LogoBolt.34e12371.png";